import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import GameProvider from "../game-provider";
import { GameCodes, IdType } from "../type";

export const useTypeAndId = () => {
  const { type, id = "" } = useParams();
  const [gameCode, setGameCode] = useState<GameCodes>(GameCodes.Unknown);
  const [idType, setIdType] = useState<IdType>(IdType.Unknown);
  useEffect(() => {
    if (!type || !id) return;
    const gameContent = GameProvider.determineGameCode(id ?? "");
    setGameCode(gameContent);
    setIdType(convertType(type));
  }, [type, id]);

  return {
    type: idType,
    id,
    gameCode,
  };
};

function convertType(type: string): IdType {
  switch (type) {
    case IdType.Rounds:
      return IdType.Rounds;
    case IdType.Plays:
      return IdType.Plays;
    case IdType.Spins:
      return IdType.Spins;
    case IdType.BetBatches:
      return IdType.BetBatches;
    default:
      return IdType.Unknown;
  }
}
